var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41152 0.000435C1.70566 0.000435 0 0.00270057 0 0.853084C0 1.708 1.16983 2.72243 1.70586 3.41209L23.883 30.0675V51.1771L13.6473 54.5885C11.9414 55.157 10.2358 56.2944 10.2358 58H47.7653C47.7653 56.2948 46.0605 55.1574 44.3537 54.5885L34.119 51.1765L34.1188 30.0664L56.2955 3.412C56.8313 2.72247 58 1.70805 58 0.853181C58 0.00227162 56.2954 0 54.5891 0L3.41152 0.000435Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassIcon);
export default __webpack_public_path__ + "static/media/glassIcon.c108ae2b065bd3dc761aaf6c0262094f.svg";
export { ForwardRef as ReactComponent };